// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1aj5s","alertIcon":"ConfirmModal_alertIcon__vVJMI"};